import { connect } from 'react-redux';
import { AppState } from '../../../../../types/store';
import { isCurrentUserProfileOwner } from '../../../../selectors/users';
import {
  getSectionLayoutZones,
  getInstalledModuleIds,
  getInstallableModuleTypes,
} from '../../../../selectors/layout';
import { addModule } from '../../../../actions/layout';
import { Props } from './ZoneGroup';

export type ConnectedKeys = 'isCurrentUserProfileOwner' | 'zones' | 'addModule';
export type ContainerProps = Without<Props, ConnectedKeys>;

const mapStateToProps = (
  state: AppState,
  props: ContainerProps
): Partial<Props> => {
  const zones = Object.keys(getSectionLayoutZones(state, props.section)).reduce(
    (result, zone) => {
      result[zone] = {
        installedModuleIds: getInstalledModuleIds(state, props.section, zone),
        installableModuleTypes: getInstallableModuleTypes(
          state,
          props.section,
          zone
        ),
      };
      return result;
    },
    {}
  );
  return {
    isCurrentUserProfileOwner: isCurrentUserProfileOwner(state),
    zones,
  };
};

const mapDispatchToProps = (
  dispatch,
  ownProps: ContainerProps
): Partial<Props> => ({
  addModule: (zone, moduleType, position) =>
    ownProps.section &&
    dispatch(
      addModule({ section: ownProps.section, zone, moduleType, position })
    ),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
);
